// extracted by mini-css-extract-plugin
export default {"section":"AboutUsSection_section__-0K5s","top":"AboutUsSection_top__fOmfK","adventages":"AboutUsSection_adventages__aeyx-","titleCenter":"AboutUsSection_titleCenter__luXfR"};